"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _pittaModules = require("@thingsw/pitta-modules");
var _Typography = require("./Typography");
var _clsx = _interopRequireDefault(require("clsx"));
var _lab = require("@material-ui/lab");
var _ThumbnailPlayback = require("../icons/ThumbnailPlayback");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// 7 Box 모델 옵션 카메라 추가

var useStyle = (0, _core.makeStyles)(function (theme) {
  return (0, _core.createStyles)({
    thumbnailBoxWrap: {
      position: "relative"
    },
    wrap: {
      display: "flex",
      alignItems: "flex-start"
    },
    wrapActive: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    img: {
      display: "flex",
      width: 112,
      height: 64,
      borderRadius: 9.33
    },
    camera: {
      display: "flex",
      alignItems: "center",
      position: "absolute",
      zIndex: 2,
      width: 94,
      height: 20,
      boxSizing: "border-box",
      backgroundColor: "".concat(_pittaModules.LightColors.primary["1"], "73"),
      padding: theme.spacing(0.5)
    },
    cameraActive: {
      height: 64,
      alignItems: "flex-start",
      paddingTop: theme.spacing(0.375)
    },
    cameraIconWrap: _objectSpread({
      display: "flex"
    }, theme.direction === "rtl" && {
      transform: "rotate(-180deg)"
    }),
    cameraIcon: {
      color: "transparent",
      width: 14,
      height: 10,
      margin: theme.spacing(0.25, 0.875, 0.25, 0.25)
    },
    playIcon: {
      display: "none"
    },
    playIconActive: {
      display: "flex",
      position: "absolute",
      zIndex: 2,
      color: _pittaModules.LightColors.primary["0"]
      // ...(theme.direction === "rtl" && { transform: "rotate(-180deg)" }),
    },

    progressWrap: {
      position: "absolute",
      top: 61,
      width: "100%"
    },
    progress: {
      height: 3
    },
    colorPrimary: {
      backgroundColor: _pittaModules.LightColors.primary["3"]
    },
    bar: {
      backgroundColor: _pittaModules.LightColors.primary["7"]
    },
    videoQualityDiv: {
      position: "absolute",
      left: 12,
      bottom: 8,
      minWidth: 23,
      height: 18,
      backgroundColor: "rgba(19, 19, 28, 0.45)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: 2,
      borderRadius: 4,
      padding: "0 4px"
    }
  });
});
var ThumbnailBox = function ThumbnailBox(props) {
  var img = props.img,
    locationType = props.locationType,
    active = props.active,
    progressIndicator = props.progressIndicator,
    progress = props.progress,
    loading = props.loading,
    videoQuality = props.videoQuality;
  var classes = useStyle(props);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    error = _useState2[0],
    setError = _useState2[1];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.thumbnailBoxWrap
  }, loading && /*#__PURE__*/_react.default.createElement(_lab.Skeleton, {
    variant: "rect",
    className: classes.img
  }), !loading && img && !error && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.wrap, active && classes.wrapActive)
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: "video",
    src: img,
    className: classes.img,
    onError: function onError(err) {
      // console.log("ThumbnailBox", "error");
      setError(true);
    }
  })), (locationType || videoQuality) && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.videoQualityDiv
  }, locationType && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    variant: "CaptionBold",
    category: "Default",
    htmlColor: _pittaModules.LightColors.primary["0"]
  }, "".concat(locationType)), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: 1.79,
      height: 1.79,
      backgroundColor: _pittaModules.LightColors.primary["0"],
      borderRadius: "50%"
    }
  })), /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    variant: "CaptionBold",
    category: "Default",
    htmlColor: _pittaModules.LightColors.primary["0"]
  }, videoQuality))), !loading && (!img || error) && /*#__PURE__*/_react.default.createElement(_ThumbnailPlayback.ThumbnailPlayback, {
    className: classes.img
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.progressWrap
  }, progressIndicator && /*#__PURE__*/_react.default.createElement(_core.ThemeProvider, {
    theme: {
      direction: "ltr"
    }
  }, /*#__PURE__*/_react.default.createElement(_core.LinearProgress, {
    variant: "determinate",
    value: progress,
    classes: {
      root: classes.progress,
      colorPrimary: classes.colorPrimary,
      bar: classes.bar
    }
  }))));
};
var _default = ThumbnailBox;
exports.default = _default;